import { useState } from "react";
import { ButtonGroup, Col, Dropdown, DropdownButton, Row, Table } from "react-bootstrap";
import { dictionaryAgreeP } from "../../../helper/dictionary";
import { toDate, toPLN } from "../../../helper/formatData";
import getLocationName from "../../../helper/getLocationName";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { setAllData } from "../../../redux/reducer/agree/agreeSliceCreate";
import { getHistDataAsync } from "../../../redux/reducer/history/histSlice";
import { selectData, selectSearch } from "../../../redux/reducer/report/reportSlice";
import { selectUserData } from "../../../redux/reducer/user/userSlice";
import styles from "../../../styles/Client.module.css";

import HistModal from "../../../comp/modal/history/HistModal";
import AgreeModalP from "../../../comp/modal/agree/agreeP/view/AgreeModal";
import AgreeModalS from "../../../comp/modal/agree/agreeS/view/AgreeModal";

//---------------------------------------------------

export default function PageReportMixTab() {
    //  react
    const [idAgree, setIdAgree] = useState(0);
    const [modalShowHist, setModalShowHist] = useState(false);
    const [modalShowAgreeP, setModalShowAgreeP] = useState(false);
    const [modalShowAgreeS, setModalShowAgreeS] = useState(false);

    // redux
    const dispatch = useAppDispatch();
    const data = useAppSelector(selectData);
    const search = useAppSelector(selectSearch);
    const { locations, access_token } = useAppSelector(selectUserData);

    //amount
    const priceIncome = data.reduce((x: any, y: any) => {
        return x + Number(y.priceIncome);
    }, 0);
    const priceSpend = data.reduce((x: any, y: any) => {
        return x + Number(y.priceSpend);
    }, 0);

    //  view
    return (
        <>
            <Row>
                <Col>
                    <strong style={{ color: "white" }}>Podsumowanie</strong>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Table striped bordered hover size="lg" responsive>
                        <thead className={styles.textCenter}>
                            <tr>
                                <th style={{ width: "80px" }}>#</th>
                                <th style={{ width: "80px" }}>ID</th>
                                <th>Przedmiot</th>
                                <th style={{ width: "250px" }}>Klient</th>
                                <th style={{ width: "120px" }}>Przychody</th>
                                <th style={{ width: "120px" }}>Wydatki</th>
                                <th style={{ width: "115px" }}>Zawarta</th>
                                <th style={{ width: "250px" }}>Lokalizacja</th>
                                <th style={{ width: "150px" }}>Status</th>
                                <th style={{ width: "150px" }}>Zrodlo</th>
                                <th style={{ width: "115px" }}>Akcje</th>
                            </tr>
                        </thead>
                        <tbody className={styles.textCenter}>
                            {data.map((obj: any, inx: any) => {
                                return (
                                    <tr key={inx} className="textCenter">
                                        <td style={{ padding: "13px 0px" }}>{inx + 1}</td>
                                        <td style={{ padding: "13px 0px" }}>{obj.id}</td>
                                        <td style={{ padding: "13px 0px" }}>
                                            {obj.item
                                                .reduce((x: any, y: any) => {
                                                    return x + ", " + y.name;
                                                }, "")
                                                .substring(1)}
                                        </td>
                                        <td style={{ padding: "13px 0px" }}>
                                            {obj.client.firstname} {obj.client.surname}
                                        </td>
                                        <td style={{ paddingTop: "13px", textAlign: "right" }}>
                                            {toPLN(obj.priceIncome)}
                                        </td>
                                        <td style={{ paddingTop: "13px", textAlign: "right" }}>
                                            {toPLN(obj.priceSpend)}
                                        </td>
                                        <td style={{ padding: "13px 0px" }}>{toDate(obj.created)}</td>
                                        <td style={{ padding: "13px 0px" }}>
                                            {getLocationName(locations, obj.id_location)}
                                        </td>
                                        <td style={{ padding: "13px 0px" }}>{dictionaryAgreeP(obj.status)}</td>
                                        <td style={{ padding: "13px 0px" }}>{obj.source}</td>
                                        <td>
                                            <DropdownButton
                                                as={ButtonGroup}
                                                key={inx}
                                                id={`dropdown-button-drop-${inx}`}
                                                drop="start"
                                                variant="outline-secondary"
                                                title="Wybierz"
                                            >
                                                <Dropdown.Item
                                                    eventKey="4"
                                                    onClick={() => {
                                                        dispatch(setAllData(obj));
                                                        obj.source === "agreeP"
                                                            ? setModalShowAgreeP(true)
                                                            : setModalShowAgreeS(true);
                                                        setIdAgree(obj.id);
                                                    }}
                                                >
                                                    Podgląd
                                                </Dropdown.Item>

                                                <Dropdown.Item
                                                    eventKey="7"
                                                    onClick={() => {
                                                        dispatch(
                                                            getHistDataAsync({
                                                                data: {
                                                                    what: obj.source,
                                                                    id_what: obj.id,
                                                                },
                                                                access_token,
                                                            })
                                                        );
                                                        setModalShowHist(true);
                                                        setIdAgree(obj.id);
                                                    }}
                                                >
                                                    Historia
                                                </Dropdown.Item>
                                            </DropdownButton>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                        <tfoot className={styles.textRight}>
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>Suma: </td>
                                <td>{toPLN(priceIncome)}</td>
                                <td>{toPLN(priceSpend)}</td>
                                <td>
                                    <strong>{toPLN(priceIncome - priceSpend)}</strong>
                                </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </Table>
                </Col>
                <AgreeModalP show={modalShowAgreeP} onHide={() => setModalShowAgreeP(false)} />
                <AgreeModalS show={modalShowAgreeS} onHide={() => setModalShowAgreeS(false)} />
                <HistModal
                    show={modalShowHist}
                    onHide={() => setModalShowHist(false)}
                    descript={`Historia umowy nr: ${idAgree}`}
                />
            </Row>
        </>
    );
}
